function MobileMenu(el) {
    this.el = el;

    this.focusedElBeforeOpen = null;
    this.focusableEls = this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    this.firstFocusableEl = this.focusableEls[0];
    this.lastFocusableEl = this.focusableEls[this.focusableEls.length - 1];

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsHideMenu')) this.hide();
    });

    document.addEventListener('keyup', e => {
        if (e.key.toLowerCase() === 'escape') this.hide();
    });

    window.addEventListener('keydown', e => {
        const tabIsPressed = e.key === 'Tab';

        if (!tabIsPressed) return;

        if (e.shiftKey) {
            if (document.activeElement === this.firstFocusableEl) {
                this.lastFocusableEl.focus();
                e.preventDefault();
            }
        }
        else {
            if (document.activeElement === this.lastFocusableEl) {
                this.firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}

MobileMenu.prototype.toggleVisibility = function() {
    if (this.el.classList.contains('visible')) this.hide();
    else this.show();
};

MobileMenu.prototype.show = function() {
    this.el.classList.add('visible');

    // Accessibility stuff
    this.focusedElBeforeOpen = document.activeElement;
    document.body.ariaHidden = true;
    this.el.ariaHidden = false;
    if (this.firstFocusableEl) this.firstFocusableEl.focus();
};

MobileMenu.prototype.hide = function() {
    this.el.classList.remove('visible');

    // Accessibility stuff
    if (this.focusedElBeforeOpen) this.focusedElBeforeOpen.focus();
    this.focusedElBeforeOpen = null;
    document.body.ariaHidden = false;
    this.el.ariaHidden = true;
};

(function() {
    const mobileMenuTriggerEl = document.querySelector('.jsMobileMenuTrigger');
    const mobileMenuEl = document.querySelector('.jsMobileMenu');

    if (mobileMenuTriggerEl && mobileMenuEl) {
        const mobileMenu = new MobileMenu(mobileMenuEl);

        mobileMenuTriggerEl.addEventListener('click', e => {
            e.preventDefault();
            mobileMenu.toggleVisibility();
        });
    }
})();